import { render, staticRenderFns } from "./SocialBookmarks.vue?vue&type=template&id=0ad71e0c&"
import script from "./SocialBookmarks.vue?vue&type=script&lang=ts&"
export * from "./SocialBookmarks.vue?vue&type=script&lang=ts&"
import style0 from "./SocialBookmarks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports